import React from "react";

const SignUpForm = ({ theme, styles }) => {
    return <div />
}

export default SignUpForm;
